"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VumClient = void 0;
const uuid_1 = require("uuid");
const VumProfileBrokenError_1 = require("./errors/VumProfileBrokenError");
class VumClient {
    constructor(authService, stage) {
        this.authService = authService;
        this.defaultBodyRequestHeaders = {
            'Content-Type': 'application/json',
        };
        this.resourceHostId = `myvw-vum-${stage}`;
    }
    // https://vum-sandbox-documentation.apps.emea.vwapps.io - getRelationsByUserWithMetadata
    async getUserVehicleRelations() {
        const response = await this.authService.get(this.resourceHostId, 'v2/users/me/relations', { traceId: (0, uuid_1.v4)() });
        if (response.status === 422) {
            throw new VumProfileBrokenError_1.VumProfileBrokenError();
        }
        if (!response.ok) {
            throw new Error(); // TODO: How to get error message
        }
        return await response.json();
    }
    // https://vum-sandbox-documentation.apps.emea.vwapps.io - getRelationsByUserAndVin
    async getUserVehicleRelation(vin) {
        const response = await this.authService.get(this.resourceHostId, `v2/users/me/relations/${vin}`, {
            traceId: (0, uuid_1.v4)(),
        });
        if (response.status === 422) {
            throw new VumProfileBrokenError_1.VumProfileBrokenError();
        }
        if (!response.ok) {
            throw new Error(); // TODO: How to get error message
        }
        return await response.json();
    }
    // https://vum-sandbox-documentation.apps.emea.vwapps.io - getRelationsByUserAndVin
    async getVehicleRelations(vin) {
        const response = await this.authService.get(this.resourceHostId, `v2/vehicles/${vin}/relations`, {
            traceId: (0, uuid_1.v4)(),
        });
        if (!response.ok) {
            throw new Error(); // TODO: How to get error message
        }
        return await response.json();
    }
    // https://vum-sandbox-documentation.apps.emea.vwapps.io
    async patchVinVehicle(vin, dataToUpdate) {
        await this.authService.patch(this.resourceHostId, `dataStorageManagement/users/me/relations?vin=${vin}`, JSON.stringify(dataToUpdate), Object.assign(Object.assign({}, this.defaultBodyRequestHeaders), { traceId: (0, uuid_1.v4)() }));
    }
    // https://vum-sandbox-documentation.apps.emea.vwapps.io
    async patchCommissionVehicle(commissionData, dataToUpdate) {
        await this.authService.patch(this.resourceHostId, 'dataStorageManagement/users/me/relations?commissionId=' +
            `${commissionData.commissionNumber}-${commissionData.bid}-${commissionData.commissionNumberYear}`, JSON.stringify(dataToUpdate), Object.assign(Object.assign({}, this.defaultBodyRequestHeaders), { traceId: (0, uuid_1.v4)() }));
    }
    // https://vum-sandbox-documentation.apps.emea.vwapps.io
    async updateUserVehicleRelation(relation) {
        const response = await this.authService.put(this.resourceHostId, 'v2/dataStorageManagement/users/me/relations', JSON.stringify(relation), Object.assign(Object.assign({}, this.defaultBodyRequestHeaders), { traceId: (0, uuid_1.v4)() }));
        if (!response.ok) {
            throw new Error(); // TODO: How to get error message
        }
    }
    // https://vum-sandbox-documentation.apps.emea.vwapps.io
    async addVinToUserVehicle(commissionId, vin) {
        const response = await this.authService.put(this.resourceHostId, `v1/dataStorageManagement/users/me/vehicles/${commissionId}/vin`, JSON.stringify({ vin }), Object.assign(Object.assign({}, this.defaultBodyRequestHeaders), { traceId: (0, uuid_1.v4)() }));
        if (!response.ok) {
            throw new Error(); // TODO: How to get error message
        }
    }
    // https://vum-sandbox-documentation.apps.emea.vwapps.io - primaryUserReset
    async resetPrimaryUser(vin) {
        const validStatusCodes = [204, 404, 409];
        const response = await this.authService.put(this.resourceHostId, `primaryUserReset/users/me/vehicles/${vin}`, undefined, { traceId: (0, uuid_1.v4)() });
        if (!validStatusCodes.includes(response.status)) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
    }
    // https://vum-sandbox-documentation.apps.emea.vwapps.io - roleReset
    async resetNonPrimaryUser(vin) {
        const response = await this.authService.put(this.resourceHostId, `users/me/vehicles/${vin}`, undefined, {
            traceId: (0, uuid_1.v4)(),
        });
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
    }
    // https://vum-sandbox-documentation.apps.emea.vwapps.io
    async addUserVehicleRelation(userVehicleRelation) {
        const response = await this.authService.post(this.resourceHostId, 'v2/dataStorageManagement/users/me/relations', JSON.stringify(userVehicleRelation), Object.assign(Object.assign({}, this.defaultBodyRequestHeaders), { traceId: (0, uuid_1.v4)() }));
        if (!response.ok) {
            throw new Error(); // TODO: How to get error message
        }
    }
    // https://vum-sandbox-documentation.apps.emea.vwapps.io - deleteVehicleInGarage
    async deleteUserVehicleRelation(userVehicleRelation) {
        var _a, _b;
        let deleteUserVehicleRelationUrl = 'users/me/vehicles';
        if ((_a = userVehicleRelation.vehicle) === null || _a === void 0 ? void 0 : _a.vin) {
            deleteUserVehicleRelationUrl += `?vin=${userVehicleRelation.vehicle.vin}`;
        }
        else {
            deleteUserVehicleRelationUrl += `?commissionId=${(_b = userVehicleRelation.vehicle) === null || _b === void 0 ? void 0 : _b.commissionId}`;
        }
        const response = await this.authService.delete(this.resourceHostId, deleteUserVehicleRelationUrl, undefined, {
            traceId: (0, uuid_1.v4)(),
        });
        if (!response.ok) {
            throw new Error(); // TODO: How to get error message
        }
    }
    // https://vum-sandbox-documentation.apps.emea.vwapps.io - deleteUserAccount
    async deleteUser() {
        const response = await this.authService.delete(this.resourceHostId, 'v1/users/me', undefined, {
            traceId: (0, uuid_1.v4)(),
        });
        if (!response.ok) {
            throw new Error(); // TODO: How to get error message
        }
    }
    // https://vum-sandbox-documentation.apps.emea.vwapps.io - Delete Guest or Secondary User by Primary User
    async removeUserFromVehicle(userId, vin) {
        const response = await this.authService.delete(this.resourceHostId, `v1/users/${userId}/vehicles/${vin}`, undefined, { traceId: (0, uuid_1.v4)() });
        if (!response.ok) {
            throw new Error(); // TODO: How to get error message
        }
    }
}
exports.VumClient = VumClient;
//# sourceMappingURL=VumClient.js.map